export function stringFormatter(input) {
    // ตรวจสอบว่าค่าเป็น null
    if (input === null) {
        return '-'; // กรณีที่เป็น null
    }

    // ตรวจสอบว่าค่าเป็นค่าว่างหรือไม่
    if (input === undefined || input === '') {
        return 'Invalid input'; // กรณีที่เป็นค่าว่าง
    }

    // ตรวจสอบว่าเป็นตัวเลขหรือไม่
    if (!isNaN(input) && typeof input !== 'boolean') {
        return Number(input); // ส่งกลับตัวเลขในรูปแบบ number
    }

    // ตรวจสอบว่าเป็นข้อความหรือไม่
    if (typeof input === 'string') {
        // เปลี่ยนตัวอักษรตัวแรกให้เป็นพิมพ์ใหญ่
        return input.charAt(0).toUpperCase() + input.slice(1);
    }

    return 'Invalid input'; // กรณีที่อินพุตไม่ตรงกับเงื่อนไขข้างต้น
}

